import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle_minus",
  "use": "icon-circle_minus-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" id=\"icon-circle_minus\">\n  <circle data-name=\"Ellipse 3 copy 4\" class=\"cls-1\" cx=\"12.5\" cy=\"12.5\" r=\"12.5\" />\n  <rect fill=\"#ffffff\" class=\"cls-2\" x=\"8\" y=\"11\" width=\"9\" height=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol